import React from "react";
import { Box, Typography, Skeleton } from "@mui/material";
import { useChatStore } from "../../../stores/chatStore";
import { ContentCard } from "../content-card/content-card";

interface UnreadLessonsPanelProps {
  onMessageClick: (messageId: string, domain: string, focus: string) => void;
}

export const UnreadLessonsPanel: React.FC<UnreadLessonsPanelProps> = ({
  onMessageClick,
}) => {
  const { lessonsToDo, isLoadingLessonsToDo, errorLessonsToDo } =
    useChatStore();

  if (isLoadingLessonsToDo) {
    return (
      <Skeleton
        variant="rectangular"
        width="100%"
        height={98}
        sx={{ borderRadius: 1 }}
      />
    );
  }
  if (errorLessonsToDo) {
    return <Typography color="error">{errorLessonsToDo}</Typography>;
  }

  const hasLessons = (lessonsToDo || []).length > 0;

  if (!hasLessons) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          padding: 4,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h6"
          color="text.secondary"
          sx={{ fontWeight: 600 }}
        >
          No lessons available
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: "300px" }}
        >
          Select the option "Retrieve a lesson" in the bottom left menu to
          generate the New Lesson
        </Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {(lessonsToDo || []).map((item, index) => (
        <ContentCard
          key={`${item.message_id}-${item.date}-${index}`}
          item={item}
          onClick={onMessageClick}
          badgeLabel="Lesson"
          showScore
        />
      ))}
    </Box>
  );
};
